module.exports = __webpack_public_path__ + "img/error-postural.f11479d0.svg";